import { render, staticRenderFns } from "./CompanyStyle.vue?vue&type=template&id=f8d3b9ae&scoped=true&"
import script from "./CompanyStyle.vue?vue&type=script&lang=js&"
export * from "./CompanyStyle.vue?vue&type=script&lang=js&"
import style0 from "./CompanyStyle.vue?vue&type=style&index=0&id=f8d3b9ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d3b9ae",
  null
  
)

export default component.exports